<template>
    <div class="monthly-climate-chart">
        <data-by-unit-chart
            :data="processedData"
            :provided-options="options"
            :height="170"
        />
        <chart-legend
            :items="legendItems"
            :unit="unitOfMeasurement"
            class="legend"
        />
    </div>
</template>
<script>
import ChartLegend from '@foundryspatial/chart-legend';
import DataByUnitChart from '@foundryspatial/data-by-unit-chart';

import scssVars from '@/assets/scss/_variables.scss';

export default {
    components: {
        ChartLegend,
        DataByUnitChart,
    },
    props: {
        /**
         * The data used to build the chart is an object containing 'line' and 'area' arrays
         * line: [
         *      58.5723164397865,
         *      ...
         * ],
         * area: [
         *      {
         *          min: 'min value for area',
         *          max: 'max value for area',
         *      }
         *      ...
         * ],
         */

        data: {
            type: Object,
            required: true,
        },
        lineColor: {
            type: String,
            required: false,
            default: scssVars.colorClimateDefaultLine,
        },
        areaColor: {
            type: String,
            required: false,
            default: scssVars.colorClimateDefaultArea,
        },
        yAxisLabel: {
            type: String,
            required: false,
            default: '',
        },
        unitOfMeasurement: {
            type: String,
            required: false,
            default: '',
        },
    },
    computed: {
        processedData() {
            const processedData = [];
            this.data.line.forEach((value, index) => {
                processedData.push({
                    month: index + 1,
                    avg: value,
                });
            });

            this.data.area.forEach((item, index) => {
                processedData[index].min = item.min;
                processedData[index].max = item.max;
            });

            return [
                {
                    unit: 'month',
                    unitKey: 'month',
                    marks: [
                        {
                            type: 'area',
                            color: this.areaColor,
                            min: 'min',
                            max: 'max',
                            minName: 'Min Projected Average for 2050s',
                            maxName: 'Max Projected Average for 2050s',
                            labelOrder: 2,
                        },
                        {
                            type: 'line',
                            color: this.lineColor,
                            value: 'avg',
                            valueName: 'Normal / Historical Average',
                            labelOrder: 1,
                        },
                    ],
                    data: processedData,
                },
            ];
        },
        options() {
            return {
                roundToDecimalPlaces: 2,
                valueAxisOptions: {
                    title: this.yAxisLabel,
                },
                padValueDomain: true,
                tooltipOnWholeChart: true,
                tooltipMeasurementUnit: this.unitOfMeasurement,
            };
        },
        legendItems() {
            return [
                {
                    legendLabel: 'Normal / Historical Average',
                    color: this.lineColor,
                    labelOrder: 1,
                    legendType: 'solidLine',
                },
                {
                    color: this.areaColor,
                    legendLabel: 'Projected Average for 2050s',
                    labelOrder: 2,
                    legendType: 'box',
                },
            ];
        },
    },
};
</script>
<style lang="scss">
.monthly-climate-chart {
    .legend {
        margin-top: 1rem;
    }
}

</style>
